import { render, staticRenderFns } from "./AttestsBase.vue?vue&type=template&id=19af5b56"
import script from "./AttestsBase.vue?vue&type=script&lang=js"
export * from "./AttestsBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports